<template>
  <div>
    <p>
      <span>Phoenix: </span>
      <span v-if="phoenix == null">Connecting{{ dots }}</span>
      <span v-show="phoenix == true" style="color: green">ONLINE</span>
      <span v-show="phoenix == false" style="color: red">OFFLINE</span>
    </p>
  </div>
</template>

<script>
export default {
  data: () => ({
    phoenix: null,
    count: 0
  }),
  //
  //  Check Phoenix server health every 30 seconds
  //
  mounted () {
    this.checkPhoenix()
    setInterval(this.checkPhoenix, 30000)
    setInterval(() => {
      if (this.count == 3) {
        this.count = 0
      } else {
        this.count++
      }
    }, 600)
  },
  computed: {
    dots () {
      let result = ''
      for (let i = 0; i < this.count; i++) {
        result += '.'
      }
      return result
    }
  },
  methods: {
    checkPhoenix () {
      console.log('checking connection to backend')
      this.$http.get('https://twilio-phx.mediasciencelabs.com/api/online').then(response => {
      // this.$http.get('http://localhost:4000/api/online').then(response => {
        if (response.body.status == 'OK') {
          this.phoenix = true
        }
      }, (reason) => {
        this.phoenix = false
      })
    }
  }
}
</script>

